@if (!!player.currentTrack) {
  <section
    class="player-mob theme-player__bg"
    [ngStyle]="
      showBlurredOverlay && isPlayerMobLg
        ? {
            'background-image':
              'linear-gradient(0deg, #101010 0%, rgba(16, 16, 16, 0) 57.65%),' +
              'url(' +
              player?.trackData.images?.original +
              ')'
          }
        : {}
    "
    [ngClass]="isPlayerMobLg ? 'player-mob_fullscreen' : 'player-mob_small'"
  >
    @if (showBlurredOverlay && isPlayerMobLg) {
      <ng-container *ngTemplateOutlet="playerMobWithBlurredOverlay"></ng-container>
    } @else {
      @if (isPlayerMobLg) {
        <ng-container *ngTemplateOutlet="playerMobLgTemplate"></ng-container>
      } @else {
        <!--  Small mobile player  -->
        <bmcore-progress-bar></bmcore-progress-bar>
        <div class="player-small-mode theme-player__bg" (click)="changePlayerMobView()">
          <div class="player-small-mode__info-box">
            <bmcore-track-descr
              [fixedBeat]="player.trackData"
              [parentComponent]="'player-mobSm'"
              [showVerificationIcon]="showVerificationIcon"
              [verificationIconSize]="12"
            >
            </bmcore-track-descr>
          </div>
          <div class="player-small-mode__controls-box">
            <bmcore-player-controls [showMobSmView]="true"></bmcore-player-controls>
          </div>
        </div>
      }
    }
  </section>
}

<ng-template #playerMobWithBlurredOverlay>
  <div class="player-mob__overlay">
    @if (isPlayerMobLg) {
      <ng-container *ngTemplateOutlet="playerMobLgTemplate"></ng-container>
    } @else {
      <!--  Small mobile player  -->
      <bmcore-progress-bar></bmcore-progress-bar>
      <div class="player-small-mode theme-player__bg" (click)="changePlayerMobView()">
        <div class="player-small-mode__info-box">
          <bmcore-track-descr
            [fixedBeat]="player.trackData"
            [parentComponent]="'player-mobSm'"
            [showVerificationIcon]="showVerificationIcon"
            [verificationIconSize]="12"
          >
          </bmcore-track-descr>
        </div>
        <div class="player-small-mode__controls-box">
          <bmcore-player-controls [showMobSmView]="true"></bmcore-player-controls>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #playerMobLgTemplate>
  <!--  Fullscreen mobile player  -->
  @if (isPlayerMobLg) {
    <div class="player-fullscreen-mode theme-player__bg">
      <header class="player-fullscreen-mode__header">
        <!-- Collapse icon -->
        <span class="player-fullscreen-mode__collapse-btn" (click)="changePlayerMobView()"
          ><bmcore-arrow-down-icon></bmcore-arrow-down-icon>
        </span>
      </header>
      <div class="player-fullscreen-mode__track-box" (click)="$event.stopPropagation()">
        <div class="player-fullscreen-mode__cover-box">
          <img
            src="{{ player?.currentTrack.images.original }}"
            alt="{{ player?.trackData.name }} cover"
            width="260"
            height="260"
            loading="lazy"
          />
        </div>
        <!-- Track body -->
        <div class="player-fullscreen-mode__info-box">
          <bmcore-beatmaker-info
            [beatmakerId]="player?.trackData.beatmakerId"
            [showVerificationIcon]="showVerificationIcon"
            [verificationIconSize]="12"
            [showFollowBtn]="showFollowBtn"
            (closePlayerMobLgEvent)="closePlayerMobLg()"
          ></bmcore-beatmaker-info>
          <bmcore-track-descr
            [fixedBeat]="player.trackData"
            [parentComponent]="'player-mobLg'"
            (closePlayerMobLgEvent)="closePlayerMobLg()"
          ></bmcore-track-descr>
        </div>
        <bmcore-track-actions
          class="player-fullscreen-mode__actions"
          [direction]="'column'"
          [showBuyBtnMobMode]="true"
          [showLikeBtn]="showLikeBtn"
          [showLikesCount]="true"
          [showFavouriteBtn]="showFavoriteBtn"
          [showShareBtn]="showShareBtn"
          [iconSize]="16"
          [track]="player?.trackData"
          (buyBtnClickEvent)="handleClickBuyBtn($event)"
          [buyBtnRouterPath]="checkIsTrackInCart(player.trackData.id) ? checkoutPage : ''"
          [isTrackInCart]="checkIsTrackInCart(player.trackData.id)"
          [showIconBtnVariant]="true"
          [iconButtonSize]="40"
        ></bmcore-track-actions>
      </div>
      <div class="player-fullscreen-mode__pr-bar-box" (click)="$event.stopPropagation()">
        <bmcore-progress-bar [showTimesInline]="true" [isPlayerMobLgView]="true"></bmcore-progress-bar>
      </div>
      <div class="player-fullscreen-mode__controls-box">
        <bmcore-player-controls
          [showRepeatBtn]="true"
          [showShuffleBtn]="true"
          [showMobLgView]="true"
        ></bmcore-player-controls>
      </div>
    </div>
  }
</ng-template>
